(function() {
  var Router, Storage,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Router = App.loadClass('core::Router');

  Storage = App.loadClass('core::Storage');

  exports.DefineRouter = (function(superClass) {
    extend(DefineRouter, superClass);

    function DefineRouter() {
      return DefineRouter.__super__.constructor.apply(this, arguments);
    }

    DefineRouter.prototype.prefix = 'FieldsDefine';

    DefineRouter.prototype.module_name = 'FieldsDefine';

    DefineRouter.prototype.register = function() {
      this.module = angular.module(this.module_name, ['ui.router', 'ui.bootstrap']);
      this.service('grower::Angular/Data/PlantingRx/Services/LegendService', ['$rootScope']);
      this.service('grower::Angular/Data/Services/LegacyHandlerService', ['$rootScope', '$timeout', 'FieldsDefine.Services.LegendService']);
      this.service('grower::Angular/Fields/Define/Services/UndoService', ['$rootScope']);
      this.service('grower::Angular/Fields/Define/Services/ZonesService', ['$http', '$rootScope']);
      this.service('grower::Angular/Fields/Define/Services/FieldsService', ['$http', '$rootScope', 'FieldsDefine.Services.ZonesService', '$q']);
      this.service('grower::Angular/Fields/Define/Services/PgisService', ['$http', '$rootScope', '$q']);
      this.service('grower::Angular/Fields/Define/Services/ValidationService', ['$state', 'FieldsDefine.Services.FieldsService', 'FieldsDefine.Services.ZonesService', 'FieldsDefine.Services.PgisService', 'Data.Services.LegacyHandlerService']);
      this.service('grower::Angular/Fields/Define/Services/IrrigationDetails', ['$http', '$rootScope']);
      this.controller('grower::Angular/Fields/Define/SidebarController', ['$scope', '$transitions', 'Core.Services.Steps', '$state', 'Core.Services.Loading', '$http', '$location', 'FieldsDefine.Services.FieldsService', 'FieldsDefine.Services.ValidationService']);
      this.controller('grower::Angular/Fields/Define/SelectZonesController', ['$scope', '$transitions', 'FieldsDefine.Services.PgisService', 'FieldsDefine.Services.ValidationService', 'FieldsDefine.Services.ZonesService']);
      this.controller('grower::Angular/Fields/Define/DefineZonesController', ['$scope', '$transitions', 'zone_type', 'FieldsDefine.Services.PgisService', 'FieldsDefine.Services.ValidationService', 'FieldsDefine.Services.UndoService']);
      this.controller('grower::Angular/Fields/Define/ZoneRadioSettingsController', ['$scope', '$transitions', 'zone_type', 'option_name', 'option_type', 'options', 'FieldsDefine.Services.ValidationService', 'FieldsDefine.Services.PgisService']);
      this.controller('grower::Angular/Fields/Define/ZonesDropdownTableController', ['$scope', '$transitions', 'zone_type', 'option_name', 'option_type', 'options', 'FieldsDefine.Services.ValidationService', 'FieldsDefine.Services.PgisService', 'FieldsDefine.Services.ZonesService']);
      this.controller('grower::Angular/Fields/Define/IrrigationSettings2Controller', ['$scope', '$transitions', 'zone_type', 'option_name', 'option_type', 'options', 'FieldsDefine.Services.ValidationService', 'FieldsDefine.Services.PgisService', 'FieldsDefine.Services.ZonesService']);
      this.controller('grower::Angular/Fields/Define/IrrigationDetailsController', ['$scope', '$transitions', 'FieldsDefine.Services.ValidationService', 'FieldsDefine.Services.IrrigationDetails', '$ngModal']);
      return this.controller('grower::Angular/Fields/Define/FinishController', ['$scope', '$transitions', 'FieldsDefine.Services.FieldsService', 'FieldsDefine.Services.PgisService', 'FieldsDefine.Services.ZonesService', '$state', '$timeout', 'FieldsDefine.Services.ValidationService']);
    };

    DefineRouter.prototype.registerRoutes = function($stateProvider) {
      return $stateProvider.state('grower.fields-define', {
        url: '/fields-define',
        templateUrl: 'backend/grower/fields/define/sidebar',
        controller: 'FieldsDefine.Controllers.SidebarController'
      }).state('grower.data-define', {
        url: 'data-define/:field_id/:year',
        templateUrl: 'backend/grower/fields/define/sidebar',
        controller: [
          '$scope', '$state', 'FieldsDefine.Services.ValidationService', '$stateParams', function($scope, $state, $serv, $stateParams) {
            var settings;
            $serv.cleanup();
            settings = {
              fid: $stateParams.field_id,
              year: $stateParams.year,
              process_mode: 'zone-add',
              from_data: true
            };
            $serv.setModeSettings(settings);
            return $state.go('grower.fields-define');
          }
        ]
      }).state('grower.fieldprint-define', {
        url: 'data-define/:request',
        templateUrl: 'backend/grower/fields/define/sidebar',
        controller: [
          '$scope', '$state', 'FieldsDefine.Services.ValidationService', '$stateParams', function($scope, $state, $serv, $stateParams) {
            var parameters, settings;
            parameters = JSON.parse($stateParams.request);
            $serv.cleanup();
            if (!App.layer_store.exists(parameters.field_id)) {
              App.layer_store.empty();
              App.layer_store.loadField(parameters.field_id);
            }
            $serv.fields.year = parameters.year;
            settings = {
              fid: parameters.field_id,
              year: parameters.year,
              crop: parameters.crop,
              redirectId: parameters.redirectId,
              redirectState: parameters.redirectState,
              step: parameters.step,
              process_mode: 'irrigation-add',
              from_data: false
            };
            $serv.setModeSettings(settings);
            return $state.go('grower.fields-define');
          }
        ]
      }).state('grower.fieldprint-edit-zone', {
        url: 'fieldprint-edit-zone/:request',
        templateUrl: 'backend/grower/fields/define/sidebar',
        controller: [
          '$scope', '$state', 'FieldsDefine.Services.ValidationService', '$stateParams', function($scope, $state, $serv, $stateParams) {
            var parameters;
            $serv.cleanup();
            parameters = JSON.parse($stateParams.request);
            if (!App.layer_store.exists(parameters.field_id)) {
              App.layer_store.empty();
              App.layer_store.loadField(parameters.field_id);
            }
            $serv.fields.fields_id = parameters.field_id;
            $serv.fields.year = parameters.year;
            $serv.setModeSettings({
              fid: parameters.field_id,
              process_mode: 'zone-edit',
              year: parameters.year,
              layers_id: parameters.layer_id,
              layers_title: parameters.layers_title,
              redirectId: parameters.redirectId,
              redirectState: parameters.redirectState,
              step: parameters.step,
              from_data: false
            });
            return $state.go('grower.fields-define');
          }
        ]
      }).state('grower.fieldprint-add-crop-irrigation', {
        url: 'fieldprint-add-crop-irrigation/:request',
        templateUrl: 'backend/grower/fields/define/sidebar',
        controller: [
          '$scope', '$state', 'FieldsDefine.Services.ValidationService', '$stateParams', function($scope, $state, $serv, $stateParams) {
            var parameters;
            $serv.cleanup();
            parameters = JSON.parse($stateParams.request);
            if (!App.layer_store.exists(parameters.field_id)) {
              App.layer_store.empty();
              App.layer_store.loadField(parameters.field_id);
            }
            $serv.fields.fields_id = parameters.field_id;
            $serv.fields.year = parameters.year;
            $serv.setModeSettings({
              fid: parameters.field_id,
              process_mode: 'add-crop',
              year: parameters.year,
              layers_id: parameters.layer_id,
              layers_title: parameters.layers_title,
              redirectId: parameters.redirectId,
              redirectState: parameters.redirectState,
              step: parameters.step,
              crop: parameters.crop,
              from_data: false
            });
            return $state.go('grower.fields-define');
          }
        ]
      }).state('grower.data-edit-zone', {
        url: 'data-edit-zone/:request',
        templateUrl: 'backend/grower/fields/define/sidebar',
        controller: [
          '$scope', '$state', 'FieldsDefine.Services.ValidationService', '$stateParams', function($scope, $state, $serv, $stateParams) {
            var fid, layers_id, layers_title, parameters, year;
            $serv.cleanup();
            parameters = JSON.parse($stateParams.request);
            fid = parameters.fields_id;
            year = parameters.year;
            layers_id = parameters.layer_id;
            layers_title = parameters.layer_title;
            return $serv.zones_service.exists(layers_id, (function(_this) {
              return function(response) {
                if (response.data.status.type === 'success') {
                  $serv.setModeSettings({
                    fid: fid,
                    process_mode: 'zone-edit',
                    year: year,
                    layers_id: layers_id,
                    layers_title: layers_title,
                    from_data: true
                  });
                  return $state.go('grower.fields-define');
                } else {
                  return $state.go('grower.data.view');
                }
              };
            })(this));
          }
        ]
      }).state('grower.fields-define.select-management-zones', {
        url: '/management-zones',
        views: {
          'sidebar-step': {
            templateUrl: 'backend/grower/fields/define/step/select-management-zones',
            controller: 'FieldsDefine.Controllers.SelectZonesController'
          }
        }
      }).state('grower.fields-define.irrigation-draw', {
        url: '/irrigation-draw',
        resolve: {
          zone_type: function() {
            return 'irrigation';
          }
        },
        views: {
          'sidebar-step': {
            templateUrl: 'backend/grower/fields/define/step/irrigation-draw',
            controller: 'FieldsDefine.Controllers.DefineZonesController'
          }
        }
      }).state('grower.fields-define.irrigation-settings1', {
        url: '/irrigation-settings-1',
        resolve: {
          zone_type: function() {
            return 'irrigation';
          },
          option_name: function() {
            return 'irrigated';
          },
          option_type: function() {
            return 'button';
          },
          options: function() {
            return [
              {
                value: 'Irrigated',
                btnclass: 'clickable-green'
              }, {
                value: 'Dryland',
                btnclass: 'clickable-red'
              }
            ];
          }
        },
        views: {
          'sidebar-step': {
            templateUrl: 'backend/grower/fields/define/step/irrigation-settings1',
            controller: 'FieldsDefine.Controllers.ZoneRadioSettingsController'
          }
        }
      }).state('grower.fields-define.irrigation-settings2', {
        url: '/irrigation-settings-2',
        resolve: {
          zone_type: function() {
            return 'irrigation';
          },
          option_name: function() {
            return 'irrigated';
          },
          option_type: function() {
            return 'select';
          },
          options: function() {
            return [
              {
                value: 20,
                name: '1'
              }, {
                value: 40,
                name: '2'
              }, {
                value: 60,
                name: '3'
              }, {
                value: 80,
                name: '4'
              }, {
                value: 100,
                name: '5'
              }
            ];
          }
        },
        views: {
          'sidebar-step': {
            templateUrl: 'backend/grower/fields/define/step/irrigation-settings2',
            controller: 'FieldsDefine.Controllers.IrrigationSettings2Controller'
          }
        }
      }).state('grower.fields-define.irrigation-details', {
        url: '/irrigation-details',
        views: {
          'sidebar-step': {
            templateUrl: 'backend/grower/fields/define/step/irrigation-details',
            controller: 'FieldsDefine.Controllers.IrrigationDetailsController'
          }
        }
      }).state('grower.fields-define.previous-crop-draw', {
        url: '/previous-crop-draw',
        resolve: {
          zone_type: function() {
            return 'previous-crop';
          }
        },
        views: {
          'sidebar-step': {
            templateUrl: 'backend/grower/fields/define/step/previous-crop-draw',
            controller: 'FieldsDefine.Controllers.DefineZonesController'
          }
        }
      }).state('grower.fields-define.previous-crop-settings1', {
        url: '/previous-crop-settings-1',
        resolve: {
          zone_type: function() {
            return 'previous-crop';
          },
          option_name: function() {
            return 'previous_crop';
          },
          option_type: function() {
            return 'button';
          },
          options: function() {
            return [
              {
                value: 'Corn (grain)',
                btnclass: 'clickable-yellow'
              }, {
                value: 'Soybeans',
                btnclass: 'clickable-green'
              }, {
                value: 'Other',
                btnclass: 'clickable-blue'
              }
            ];
          }
        },
        views: {
          'sidebar-step': {
            templateUrl: 'backend/grower/fields/define/step/previous-crop-settings1',
            controller: 'FieldsDefine.Controllers.ZonesDropdownTableController'
          }
        }
      }).state('grower.fields-define.productivity-draw', {
        url: '/productivity-draw',
        resolve: {
          zone_type: function() {
            return 'productivity';
          }
        },
        views: {
          'sidebar-step': {
            templateUrl: 'backend/grower/fields/define/step/productivity-draw',
            controller: 'FieldsDefine.Controllers.DefineZonesController'
          }
        }
      }).state('grower.fields-define.productivity-settings1', {
        url: '/productivity-settings-1',
        resolve: {
          zone_type: function() {
            return 'productivity';
          },
          option_name: function() {
            return 'productivity';
          },
          option_type: function() {
            return 'button';
          },
          options: function() {
            return [
              {
                value: 'High',
                btnclass: 'clickable-green'
              }, {
                value: 'Med',
                btnclass: 'clickable-yellow'
              }, {
                value: 'Low',
                btnclass: 'clickable-red'
              }
            ];
          }
        },
        views: {
          'sidebar-step': {
            templateUrl: 'backend/grower/fields/define/step/productivity-settings1',
            controller: 'FieldsDefine.Controllers.ZoneRadioSettingsController'
          }
        }
      }).state('grower.fields-define.productivity-settings2', {
        url: '/productivity-settings-2',
        resolve: {
          zone_type: function() {
            return 'productivity';
          },
          option_name: function() {
            return 'productivity';
          },
          option_type: function() {
            return 'select';
          },
          options: function() {
            return [
              {
                value: 20,
                name: '1'
              }, {
                value: 40,
                name: '2'
              }, {
                value: 60,
                name: '3'
              }, {
                value: 80,
                name: '4'
              }, {
                value: 100,
                name: '5'
              }
            ];
          }
        },
        views: {
          'sidebar-step': {
            templateUrl: 'backend/grower/fields/define/step/productivity-settings2',
            controller: 'FieldsDefine.Controllers.ZoneRadioSettingsController'
          }
        }
      }).state('grower.fields-define.finish', {
        url: '/finish',
        views: {
          'sidebar-step': {
            templateUrl: 'backend/grower/fields/define/step/finish',
            controller: 'FieldsDefine.Controllers.FinishController'
          }
        }
      });
    };

    return DefineRouter;

  })(Router);

}).call(this);
